/** Paths that carry a user identifier in a segment without digits, so the generic rule misses it. */
const USER_PATH_RULES: [RegExp, string][] = [
  [/^(\/api\/user\/settings\/)[^/]+/, '$1:userName'],
  [/^(\/api\/user\/banner\/[^/]+\/)[^/]+/, '$1:userName'],
];

/**
 * IDs, location numbers, UUIDs and emails: all digits, 3+ digits anywhere, or an `@`.
 * Names like `emailStatsV2`, `v2` and `lapsed_breakfast` are kept.
 */
const ID_SEGMENT = /^\d+$|(?:\d\D*){3}|@/;
const MAX_KEPT_SEGMENT_LENGTH = 40;

export interface NormalizedEndpoint {
  host: string;
  endpoint: string;
}

/**
 * Reduces a request URL to its host and a bounded path template (`/api/location/:id/eventStats`),
 * dropping the query string, so failures group by endpoint and carry no IDs or personal data.
 */
export function normalizeEndpoint(url: string): NormalizedEndpoint {
  let parsed: URL;
  try {
    parsed = new URL(url, globalThis.location?.origin ?? 'http://localhost');
  } catch {
    return { host: '', endpoint: url.split(/[?#]/)[0] };
  }

  const path = USER_PATH_RULES.reduce((current, [pattern, replacement]) => current.replace(pattern, replacement), parsed.pathname);
  const endpoint = path
    .split('/')
    .map(segment => (ID_SEGMENT.test(segment) || segment.length > MAX_KEPT_SEGMENT_LENGTH) ? ':id' : segment)
    .join('/');

  return { host: parsed.host, endpoint: endpoint || '/' };
}
